"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAnalytics = void 0;
var METHODS = [
    'trackLink',
    'trackForm',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'on',
    'setAnonymousId',
];
var analyticsProxy = METHODS.reduce(function (memo, method) {
    memo[method] = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = window.analytics)[method].apply(_a, args);
    };
    return memo;
}, {});
function createAnalytics(apiKey, loadOptions, scope, defer) {
    if (loadOptions === void 0) { loadOptions = undefined; }
    if (scope === void 0) { scope = window; }
    if (defer === void 0) { defer = false; }
    scope.analytics = scope.analytics || [];
    var analytics = scope.analytics;
    if (analytics.initialize) {
        return analyticsProxy;
    }
    if (analytics.invoked) {
        return analyticsProxy;
    }
    analytics.invoked = true;
    analytics.methods = METHODS;
    analytics.factory = function (method) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (['track', 'screen', 'alias', 'group', 'page', 'identify'].indexOf(method) > -1) {
                var c = scope.document.querySelector("link[rel='canonical']");
                args.push({
                    __t: 'bpc',
                    c: (c && c.getAttribute('href')) || undefined,
                    p: scope.location.pathname,
                    u: scope.location.href,
                    s: scope.location.search,
                    t: scope.document.title,
                    r: scope.document.referrer,
                });
            }
            args.unshift(method);
            analytics.push(args);
            return analytics;
        };
    };
    for (var i = 0; i < analytics.methods.length; i += 1) {
        var key = analytics.methods[i];
        analytics[key] = analytics.factory(key);
    }
    analytics.load = function (key, options) {
        if (key === void 0) { key = apiKey; }
        if (options === void 0) { options = loadOptions; }
        var script = scope.document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
        var first = scope.document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
        analytics._loadOptions = options;
    };
    analytics.SNIPPET_VERSION = '5.2.1';
    if (!defer) {
        analytics.load(apiKey, loadOptions);
    }
    return analyticsProxy;
}
exports.createAnalytics = createAnalytics;
//# sourceMappingURL=index.js.map